import React, { useEffect, useState } from "react";
const reviews = [];
const GetResenias = async () => {
  try {
    const response = await fetch("https://frabas.cl/backend/Resenias/ObtenerResenias.php");
    const data = await response.json();
    if (data.success) {
      console.log('data',data)
      return data.data; // Asegúrate que esta clave contiene el array de reseñas
    }
  } catch (error) {
    console.error("Error al obtener reseñas:", error);
    return [];
  }
};

const ReviewCard = ({ review }) => (
  <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-xs flex flex-col justify-between h-full">
    <div>
      <div className="flex items-center justify-center mb-2">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-5 h-5 ${i < review.valoracion ? "text-red-800" : "text-gray-300"}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 15l-5.878 3.09 1.122-6.545L.488 6.91l6.561-.955L10 0l2.951 5.955 6.561.955-4.756 4.635 1.122 6.545z" />
          </svg>
        ))}

      </div>
      <h3 className="text-lg font-semibold text-center">{review.titulo}</h3>
      <p className="text-gray-600 text-sm mt-2 text-center">{review.descripcion}</p>
    </div>
    <div className="flex flex-col items-center mt-4 border-t pt-3">
      <p className="text-sm font-medium">{review.nombre}</p>
      <p className="text-xs text-gray-500">{review.fecha}</p>
    </div>
  </div>
);

const ReviewSection = ({ max }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchResenias = async () => {
      const data = await GetResenias();
      setReviews(data || []);
    };
    fetchResenias();
  }, []);

  const visibleReviews = max ? reviews.slice(0, max) : reviews;

  return (
    <section className="py-12 bg-white-100">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-2xl font-bold mb-8 text-center">Últimas reseñas</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
          {visibleReviews.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewSection;
